import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SearchSelect from "components/common/SearchSelect";
import {
    fetchAdministrators,
    fetchSupervisors,
    fetchAccountManagers,
    fetchMerchandisers
} from "actions/employeeActions";
import counterEmailFilter from "components/menu/email-blaster/counter-email-filter";
import counterEmailList from "components/menu/email-blaster/counter-email-types";
import EmailTable from "components/menu/email-blaster/email-table";

class FromDirectory extends React.Component {
    dateFormat = "YYYY-MM-DD";

    typeOptions = [
        {
            label: "Administrators",
            value: "administrators"
        },
        {
            label: "Supervisors",
            value: "supervisors"
        },
        {
            label: "Account Managers",
            value: "accountManagers"
        },
        {
            label: "Merchandisers",
            value: "merchandisers"
        },
    ];

    constructor(props) {
        super(props);

        this.state = {
            selectedType: null,
            emailsList: [],
            counterEmail: 0,
            selectedUsers: [],
        };

        this.handleSelectUserEmails = this.handleSelectUserEmails.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.getSelectedUsersEmail = this.getSelectedUsersEmail.bind(this);
    }

    handleSelect = (name, option) => {
        this.setState({
            [name]: option
        });
    };

    handleRadio = (ev) => {
        const {
            name,
            value
        } = ev.target;
        this.setState({
            [name]: parseInt(value, 10)
        });
    };

    handleSelectUserEmails = (email) => {
        let selectedUsers = Object.assign([], this.state.selectedUsers);
        if (email === false) {
            if (selectedUsers.length) {
                selectedUsers = [];
            } else {
                selectedUsers = counterEmailFilter(
                    this.getUsersEmail(),
                    this.state.counterEmail
                ).map(value => value.email);
            }
        } else {
            const index = selectedUsers.indexOf(email);
            if (index > -1) {
                selectedUsers.splice(index, 1);
            } else {
                selectedUsers.push(email);
            }
        }

        this.setState({
            selectedUsers
        });
    };

    handleLoad = () => {
        const { selectedType } = this.state;
        if (selectedType !== null) {
            if (selectedType.value === "administrators") {
                this.props.fetchAdministrators();
            } else if (selectedType.value === "supervisors") {
                this.props.fetchSupervisors();
            } else if (selectedType.value === "accountManagers") {
                this.props.fetchAccountManagers();
            } else if (selectedType.value === "merchandisers") {
                this.props.fetchMerchandisers();
            }
        }
    };

    getUsersEmail = () => {
        if (this.state.selectedType) {
            switch (this.state.selectedType.value) {
                case "administrators":
                    return this.props.administrators;
                case "supervisors":
                    return this.props.supervisors;
                case "accountManagers":
                    return this.props.accountManagers;
                case "merchandisers":
                    return this.props.merchandisers;
                default:
                    return [];
            }
        }
        return [];
    };

    getSelectedUsersEmail = () => {
        const usersEmails = Object.assign([], this.state.selectedUsers);
        this.setState({
            selectedUsers: []
        });
        return usersEmails;
    };

    render() {
        const {
            selectedType,
            counterEmail,
            selectedUsers
        } = this.state;

        const users = counterEmailFilter(this.getUsersEmail(), counterEmail);

        return (
            <div className="pt-2 pb-2">
                <div className="input-group mb-3">
                    <div className="input-group-prepend w-25">
                        <span className="input-group-text justify-content-end w-100">Type:</span>
                    </div>
                    <SearchSelect
                        options={this.typeOptions}
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        value={selectedType}
                        onChange={(option) => this.handleSelect("selectedType", option)}
                        className="w-75"
                    />
                </div>
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-inline-flex align-items-center">
                        <label className="mb-0">
                            Counter Email?
                        </label>
                        <div className="ml-2">
                            {counterEmailList.map(perRadio => (
                                <div className="form-check-inline" key={perRadio.value}>
                                    <label className="form-check-label">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            name="counterEmail"
                                            value={perRadio.value}
                                            onChange={this.handleRadio}
                                            checked={counterEmail === perRadio.value}
                                        /> {perRadio.title}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            className="btn btn-primary"
                            onClick={this.handleLoad}
                        >
                            Load
                        </button>
                    </div>
                </div>

                <EmailTable
                    height={378}
                    users={users}
                    selectedUsers={selectedUsers}
                    onSelectUserEmails={this.handleSelectUserEmails}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.globalFormErrors.loading,
    administrators: state.employee.administrators,
    supervisors: state.employee.supervisors,
    accountManagers: state.employee.accountManagers,
    merchandisers: state.employee.merchandisers,
});

const mapStateToDispatch = dispatch => ({
    fetchAdministrators: bindActionCreators(fetchAdministrators, dispatch),
    fetchSupervisors: bindActionCreators(fetchSupervisors, dispatch),
    fetchAccountManagers: bindActionCreators(fetchAccountManagers, dispatch),
    fetchMerchandisers: bindActionCreators(fetchMerchandisers, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
    null,
    { withRef: true }
)(FromDirectory);
